export default __webpack_public_path__ + "media/images/features/hida/grid-3-07be821eeddcf792c1a718d2489a23e6.png";